import styled from '@emotion/styled';
import { Box } from '@mui/material';
import { ContentEditable } from '@lexical/react/LexicalContentEditable';
import { highlight, primary } from '_lex/_foundations/phxColors';

export const MuiContentEditable = styled(ContentEditable)({
  minHeight: 200,
  width: '100%',
  padding: '0 8px',
  borderRadius: 5,
  paddingTop: 2,
  paddingLeft: 10,
  position: 'relative',
  outline: 'none',
  '&[contenteditable=false]': {
    minHeight: 0,
    padding: 0,
  },

  '.text-entity': {
    fontSize: '16px',
    lineHeight: 1.5,
    fontWeight: 400,
    letterSpacing: '-0.48px',
    padding: '0 8px',
    borderRadius: 4,
    color: highlight[900],
    border: `1px solid ${highlight[800]}`,
    display: 'inline-flex',
    '&:before': { content: '"["' },
    '&:after': { content: '"]"' },
  },
  '.text-entity.text-entity-resolved:before, .text-entity.text-entity-resolved:after': {
    content: 'none',
  },
  '.phx-cross-ref-link': {
    color: primary[800],
    display: 'inline-flex',
    textDecoration: 'none',
    '&:hover': {
      textDecoration: 'underline',
    },
  },
});

export const EditorPlaceholder = styled(Box)({
  position: 'absolute',
  top: 15,
  left: 10,
  userSelect: 'none',
  display: 'inline-block',
  pointerEvents: 'none',
});
